import { useAuth0Session } from '@/hooks/useAuth0Session';
import { useAuthToken } from '@/hooks/useAuthToken';
import { useIsUserRegionSameAsWidgetRegion } from '@/hooks/useIsUserRegionSameAsWidgetRegion';
import { useKinde } from '@/hooks/useKinde';
import { getLinkedAccountAccess } from '@/pages/api/scribeOpenAPI';
import { widgetTokenAtom } from '@heidi/integrations/ehr/data/atoms';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

export const GET_LINKED_ACCOUNT_ACCESS =
  '/api/v2/ml-scribe/open-api/users/linked-account/access';

export function useQueryLinkedAccountAccess() {
  const widgetToken = useAtomValue(widgetTokenAtom);
  const reduxToken = useAuthToken();
  const { accessToken: auth0Token } = useAuth0Session();
  const { getToken } = useKinde();
  const { userRegionSameAsWidgetRegion } = useIsUserRegionSameAsWidgetRegion();

  const kindeToken = getToken?.();

  // Check for token from either Redux (Kinde or Auth0 after sign-in) or Auth0 session
  const authToken = reduxToken || auth0Token || kindeToken;

  // need to be logged in (Auth0 or Kinde) and have a token from the widget
  // before we call this or we get a 401 if we call the wrong region
  return useQuery({
    enabled: !!widgetToken && !!authToken && userRegionSameAsWidgetRegion,
    queryKey: [GET_LINKED_ACCOUNT_ACCESS],
    queryFn: async () => {
      const { data } = await getLinkedAccountAccess();
      return data;
    },
  });
}
